import { graphql } from "relay-runtime"

export const deForceDeleteProgressNoteMutation = graphql`
  mutation deForceDeleteProgressNoteMutation($input: De_forceDeleteProgressNoteInput!, $connections: [ID!]!) {
    forceDeleteProgressNote: de_forceDeleteProgressNote(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      progressNote: de_ProgressNote {
        id @deleteEdge(connections: $connections)
      }
    }
  }
`
